import '@fontsource/raleway/300.css';
import '@fontsource/raleway/400.css';
import '@fontsource/raleway/500.css';
import '@fontsource/raleway/600.css';
import '@fontsource/raleway/700.css';
import '@fontsource/inter/300.css';
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import '~/scss/pixwel.scss';
import '~/tailwind.css';
import '~/node_modules/video.js/dist/video-js.css';
import '~/node_modules/react-datepicker/dist/react-datepicker.css';
import '~/node_modules/react-circular-progressbar/dist/styles.css';
